import {
    server
} from "@/api";

const prefix = 'api/certificates'

const adminPrefix = 'api/admin/certificates'

export const all = async () => {
    return await server().get(prefix + '/all')
}

export const paginate = async (data = {}) => {
    return await server().get(prefix, { params: data })
}

export const admin = {
    paginate: async (data = {}) => {
        return await server().get(adminPrefix, { params: data })
    },
    store: async (data) => {
        return await server().post(adminPrefix, data)
    },
    update: async (id, data) => {
        return await server().put(adminPrefix + '/' + id, data)
    },
    destroy: async (id) => { 
        return await server().delete(adminPrefix + '/' + id)
    }
}


const certificatesApi = {
    all,
    paginate,
    admin
}

export default certificatesApi; 